import React from 'react';
import Header from './Header';
import InquirySection from './InquirySection';
import Footer from './Footer';
import './InquiryPage.css';

function InquiryPage() {
  return (
    <div className="inquiry-page">
      <Header />
      <main className="inquiry-page-main">
        <InquirySection
          headline="Looking for Reliable Housekeeping Services?"
          reassurance="Our team will contact you within 24 hours."
        />
      </main>
      <Footer />
    </div>
  );
}

export default InquiryPage;
